<template>
  <div>
    <h3>{{ $t("notifications.list.title") }}</h3>
    <div class="section-container">
      <SwitchButtons
        name="notifications"
        :values="types"
        :onChange="getNotifications"
      />
      <div class="cards-container">
        <div class="btn-container" @click="newNotif">
          <InfoCard :addBtn="true">+</InfoCard>
        </div>
        <InfoCard
          v-for="(newsItem, index) in news"
          :key="index"
          :status="newsItem.type == 'alert'"
          :color="newsItem.priority"
        >
          <template #header>{{ newsItem.title }}</template>
          <template #sub>
            <small>{{ dateFormat(newsItem.createdAt) }}</small>
          </template>
          <template>{{ newsItem.subtitle }}</template>
          <template #left-control>
            <!-- Notificar -->
          </template>
          <template #right-control>
            <router-link
              v-if="newsItem.notificationId"
              class="icons-black"
              :to="{
                name: 'News Edit',
                params: {
                  id: newsItem.notificationId,
                },
              }"
            >
              <i class="far fa-edit"></i>
            </router-link>
            <span
              class="icons-black"
              @click="openModal(newsItem.notificationId)"
            >
              <i class="far fa-trash-alt"></i>
            </span>
          </template>
        </InfoCard>
      </div>
    </div>
    <!-- Modal -->
    <Modal v-if="modalActive" v-on:closeModal="closeModal">
      <template #header>
        <h6 class="modal-title">{{ $t("deleteAlert.title") }}</h6>
      </template>
      <template>
        <p>{{ $t("deleteAlert.body") }}</p>
      </template>
      <template #footer>
        <div class="controls">
          <span class="control cancel-btn" @click="closeModal">{{
            $t("deleteAlert.cancel")
          }}</span>
          <button
            type="control button"
            class="btn btn-dark control delete-btn"
            :disabled="isLoading"
            @click="deleteAlert"
          >
            {{ $t("deleteAlert.delete") }}
          </button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import NotificationService from "@/lib/api/Notification";
const InfoCard = () => import("@/components/InfoCard");
const SwitchButtons = () => import("@/components/Switch");
const Modal = () => import("@/components/Modal");
import moment from "moment";

export default {
  name: "NewsList",
  components: {
    InfoCard,
    SwitchButtons,
    Modal,
  },
  data: function () {
    return {
      news: [{}],
      isLoading: false,
      modalActive: false,
      notifId: null,
      alertType: null,
    };
  },
  computed: {
    types: function () {
      if (this.userRole === "CARE") {
        return [
          {
            label: this.$t("notifications.alerts"),
            value: "alert",
          },
        ];
      }
      return [
        {
          label: this.$t("notifications.all"),
          value: null,
        },
        {
          label: this.$t("notifications.notices"),
          value: "notice",
        },
        {
          label: this.$t("notifications.alerts"),
          value: "alert",
        },
        // {
        //   label: this.$t("notifications.transport"),
        //   value: "transport",
        // },
      ];
    },
    userRole() {
      return this.$store.getters["session/role"];
    },
  },
  beforeMount: function () {
    this.$store.commit("users/SET_USERS", null);
    if (this.userRole === "CARE") {
      this.getNotifications("alert");
    } else {
      this.getNotifications();
    }
  },
  methods: {
    dateFormat: function (date) {
      return moment(date).locale(this.$i18n.locale).format("LL");
    },
    newNotif: function () {
      this.$router.push({
        name: "News New",
        query: {
          type: this.alertType,
        },
      });
    },
    getNotifications: async function (type) {
      this.alertType = type;
      this.$store.commit("global/SET_LOADING", true);
      const service = new NotificationService();
      try {
        const response = await service.getNotifications(type);
        this.news = response.data.notifications;

        this.$store.commit("global/SET_LOADING", false);
      } catch (error) {
        this.$store.commit("global/SET_LOADING", false);
        throw error;
      }
    },
    openModal: function (id) {
      this.notifId = id;
      this.modalActive = true;
    },
    closeModal: function (id) {
      this.notifId = null;
      this.modalActive = false;
    },
    deleteAlert: async function () {
      this.$store.commit("global/SET_LOADING", true);
      this.isLoading = true;
      const service = new NotificationService();
      try {
        await service.deleteNotification(this.notifId);
        this.isLoading = false;
        this.$store.commit("global/SET_LOADING", false);
        this.closeModal();
        this.getNotifications(this.alertType);
      } catch (error) {
        this.isLoading = false;
        this.$store.commit("global/SET_LOADING", false);
        throw error;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.section-container {
  margin: 40px 0px;

  .section-title {
    margin-bottom: 10px;
  }
  .cards-container {
    display: flex;
    // flex-wrap: wrap;
    flex-wrap: wrap;
    flex-direction: row;
    // align-items: flex-start;
    justify-content: flex-start;
  }
  .btn-container {
    display: contents;
  }
}

.edit-btn {
  color: $black;
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);

  &:hover {
    color: $black;
  }
}
.delete-btn {
  @extend %audi;
  color: $black;
  cursor: pointer;
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);

  &:hover {
    color: $warn_red;
    text-decoration: underline;
  }
}
.modal-title {
  margin: 0;
}
.controls {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.controls .control {
  margin-left: 15px;
  font-size: 16px;
  cursor: pointer;
}
.control.cancel-btn {
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);

  &:hover {
    text-decoration: underline;
  }
}
.control.delete-btn {
  @extend %audi-b;
  color: $white;
  background-color: $black;
  border-color: $black;
  padding: 10px 20px;
  border-radius: 0px;
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);

  &:hover {
    background-color: $warn_red;
    border-color: $warn_red;
  }
}
.icons-black {
  color: #000;
  font-size: 16px;
  cursor: pointer;
}
.icons-black:hover {
  color: #000;
}
</style>
